<!-- xs sm md lg xl -->
<template>
  <v-container grid-list-md :style="$vuetify.breakpoint.xl ? 'max-width: 70%' : $vuetify.breakpoint.smAndDown ? 'max-width: 95%' : ''">
    <v-layout wrap>
      <v-flex xs10>
        <v-img class="img-responsive" src="logo.png" :max-width="$vuetify.breakpoint.smAndDown ? 120 : 180"></v-img>
      </v-flex>
      <v-flex xs2 class="text-right">
        <v-img
          :style="`float: right; margin-right: ${$vuetify.breakpoint.smAndDown ? '-20px;' : '-30px'};`"
          class="img-responsive"
          src="folhinha.png"
          :max-width="$vuetify.breakpoint.smAndDown ? 80 : 120"
        ></v-img>
      </v-flex>

      <v-flex xs12 v-if="$vuetify.breakpoint.smAndUp">
        <v-tabs v-model="tab" class="white" center-active show-arrows slider-color="#457d30" color="#457d30">
          <v-tab v-for="(item, i) in menu" :key="i" @click="click(i)">
            <span class="p12"
              ><b>{{ menu[i] }}</b></span
            >
          </v-tab>
        </v-tabs>
      </v-flex>

      <v-flex xs12>
        <v-app-bar-nav-icon v-if="$vuetify.breakpoint.xs" @click="drawer = !drawer"></v-app-bar-nav-icon>

        <v-navigation-drawer v-model="drawer" absolute left>
          <v-list nav dense>
            <v-list-item-group v-model="tab">
              <v-list-item v-for="(item, i) in menu" :key="i" @click="click(i)">
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="p12">{{ menu[i].toUpperCase() }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>
      </v-flex>

      <v-flex xs12>
        <v-tabs-items v-model="tab">
          <v-tab-item active>
            <BemVindo />
          </v-tab-item>

          <v-tab-item>
            <Sobre />
          </v-tab-item>

          <v-tab-item>
            <Blog />
          </v-tab-item>

          <v-tab-item>
            <Hospedagem :contato.sync="contato" :reservas.sync="reservas" />
          </v-tab-item>

          <v-tab-item>
            <Reservas />
          </v-tab-item>

          <v-tab-item>
            <Artesanato />
          </v-tab-item>

          <v-tab-item>
            <Experiencias :blog.sync="blog" />
          </v-tab-item>

          <v-tab-item>
            <Contato />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BemVindo from "@/views/BemVindo.vue";
import Sobre from "@/views/Sobre.vue";
import Blog from "@/views/Blog.vue";
import Hospedagem from "@/views/Hospedagem.vue";
import Reservas from "@/views/Reservas.vue";
import Artesanato from "@/views/Artesanato.vue";
import Experiencias from "@/views/Experiencias.vue";
import Contato from "@/views/Contato.vue";

export default {
  components: {
    BemVindo,
    Sobre,
    Blog,
    Hospedagem,
    Reservas,
    Artesanato,
    Experiencias,
    Contato
  },
  data() {
    return {
      drawer: false,
      tab: 0,
      menu: ["Bem Vindo", "Quem Somos", "Blog", "Hospedagem", "Reservas", "Cerâmica/Bambu", "Experiências", "Contato"],
      contato: false,
      blog: false,
      reservas: false
    };
  },
  methods: {
    click(tab) {
      if (this.tab == tab && this.$vuetify.breakpoint.xl) {
        this.tab = 0;
      }
      setTimeout(() => {
        this.tab = tab;
      }, 300);
      this.drawer = false;
    }
  },
  watch: {
    contato(val) {
      if (val) {
        this.tab = 8;
        this.contato = false;
      }
    },
    blog(val) {
      if (val) {
        this.tab = 2;
        this.blog = false;
      }
    },
    reservas(val) {
      if (val) {
        this.tab = 4;
        this.reservas = false;
      }
    }
  },
  created() {
    var limpar = false;
    if (this.$route.query.hasOwnProperty("sobre")) {
      this.tab = 1;
      limpar = true;
    } else if (this.$route.query.hasOwnProperty("blog")) {
      this.tab = 2;
      limpar = false;
    } else if (this.$route.query.hasOwnProperty("hospedagem")) {
      this.tab = 3;
      limpar = true;
    } else if (this.$route.query.hasOwnProperty("reservas")) {
      this.tab = 4;
      limpar = true;
    } else if (this.$route.query.hasOwnProperty("artesanato")) {
      this.tab = 5;
      limpar = true;
    } else if (this.$route.query.hasOwnProperty("experiencias")) {
      this.tab = 6;
      limpar = true;
    }
    if (limpar) {
      this.$router.push("/");
    }
  }
};
</script>

<style></style>
